// Copyright (c) 2017 Deere & Company

import AllClaimsFacetsContainer from './all-claims-facets-container';
import Facets from '../../state/facets';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../../../shared/services/get-date-format';

const getStateToBindToContainerProps = state => ({
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    facets: new Facets({
        ...state.claims.allClaims.facets,
        claimStatusFacet: {
            ...state.claims.allClaims.facets.claimStatusFacet,
            allowedStatus: state.user.details.settings.claims.status.selectedStatuses
        },
        dealerAccountsFacet: {
            ...state.claims.allClaims.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AllClaimsFacetsContainer);



// WEBPACK FOOTER //
// ./src/claim/all-claims/components/all-claims-facets/index.js